import React, { useState, useEffect } from 'react';
import { GlobalStyle, Box, Goals, Bod, Miss, Text, Cont} from './style';
import Axios from 'axios';

function Missing (){
    const [data, setData] = useState(
        [{names: 'Cant reach database, enjoy this tasty boi instead', images: 'goals.jpg'}]
    )
   

    useEffect(() => {
        Axios.get('http://memerepository.asuscomm.com:8080/').then(response =>{
            setData(response.data)
        })
    },[])

    return(
        <div>
            <Text>MISSING PERSONS</Text>
            <Cont>
            <Miss src={'missing1.jpg'} />
            Harrison Feepgood
            Missing: A few Minutes Ago
            </Cont>
            <Cont>
            <Miss src={'misssing2.jpg'} />
            Michael Potter <br />
            Missing: 9/14/18 <br />
            Michael went missing after he attended his wife's bris.
            He is known throughout the woods as TImbo, and he loves fishing.
            If found please contact Andrew.
            </Cont>
            { data.map((item,key) =>
             <Cont>
                 <Miss src={item.images} />
                 {item.names}
            </Cont>
            )}
        </div>
    )
}

export default Missing;